module.exports = __webpack_public_path__ + "static/weather-52a4a4b69811d7bfd0960569854d16cd.png";